import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_BELL: GlameraIconDefinition = {
  name: 'bell-ring',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-bell-ring">
      <path class="glm-bell-clapper" d="M10.268 21a2 2 0 0 0 3.464 0"></path>
      <path class="glm-bell-wave glm-bell-wave-right" d="M22 8c0-2.3-.8-4.3-2-6"></path>
      <path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"></path>
      <path class="glm-bell-wave glm-bell-wave-left" d="M4 2C2.8 3.7 2 5.7 2 8"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-bell-ring-icon, glamera-bell-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './bell.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class BellRingIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_BELL;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
